import {createFileRoute} from '@tanstack/react-router'
import {secondLevelIndexRoute} from "../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/')({
    ...secondLevelIndexRoute("/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
})
